import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Contact = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/homepage`);
      setContent(response.data.content);
    } catch (error) {
      console.error('Error fetching homepage content:', error);
    }
  };

  const getWhatsAppLink = () => {
    if (content?.whatsappNumber) {
      const cleanNumber = content.whatsappNumber.replace(/\D/g, '');
      return `https://wa.me/${cleanNumber}`;
    }
    return '#';
  };

  if (!content) {
    return null;
  }

  return (
    <section id="contact" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="bg-gradient-to-r from-gray-900 to-amber-800 bg-clip-text text-transparent">
              {content.contactTitle}
            </span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {content.contactSubtitle}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <Card className="border-0 shadow-2xl bg-gradient-to-br from-white to-gray-50">
            <CardContent className="p-6 md:p-8">
              <div className="space-y-6">
                {/* Email Section */}
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-amber-100 to-amber-200 mb-3">
                    <Mail className="w-7 h-7 text-amber-700" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{content.contactEmailLabel}</h3>
                  <a
                    href={`mailto:${content.contactEmail}`}
                    className="text-base text-amber-700 hover:text-amber-800 font-medium transition-colors duration-300"
                  >
                    {content.contactEmail}
                  </a>
                </div>

                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-4 bg-gradient-to-br from-white to-gray-50 text-gray-500">{content.contactOrText}</span>
                  </div>
                </div>

                {/* WhatsApp Section */}
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-green-100 to-green-200 mb-3">
                    <MessageCircle className="w-7 h-7 text-green-700" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{content.contactWhatsappLabel}</h3>
                  <a
                    href={getWhatsAppLink()}
                    className="inline-block no-underline"
                  >
                    <Button
                      size="lg"
                      className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white transition-all duration-300 shadow-lg hover:shadow-xl group"
                    >
                      <MessageCircle className="w-5 h-5 mr-2" />
                      {content.contactWhatsappButtonText}
                    </Button>
                  </a>
                  <div className="mt-3 text-center">
                    <p className="text-xs text-gray-600 mb-1">{content.contactWhatsappSubtext}</p>
                    <a
                      href={getWhatsAppLink()}
                      className="text-base font-semibold text-green-700 hover:text-green-800 transition-colors"
                    >
                      {content.whatsappNumber}
                    </a>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};